(() => {
  const thresholdDefault = 300001;
  const formatRupees = (minorUnits) => {
    const amount = Math.max(0, Number(minorUnits) || 0) / 100;
    return "Rs. " + amount.toLocaleString("en-PK", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  };
  const getEligibleSubtotal = (cart) => {
    const original = Number(cart.original_total_price);
    const discounts = Number(cart.total_discount || 0);
    if (Number.isFinite(original)) return Math.max(0, original - discounts);
    return Math.max(0, Number(cart.items_subtotal_price ?? cart.total_price ?? 0));
  };
  const renderProgress = (cart) => {
    if (!cart) return;
    const subtotal = getEligibleSubtotal(cart);
    const itemCount = Number(cart.item_count ?? cart.total_quantity ?? 0);
    document.querySelectorAll("[data-fitty-free-shipping]").forEach((root) => {
      const threshold = Number(root.dataset.thresholdCents) || thresholdDefault;
      const message = root.querySelector("[data-fitty-free-shipping-message]");
      const bar = root.querySelector("[data-fitty-free-shipping-bar]");
      const eligible = subtotal >= threshold;
      root.dataset.subtotalCents = String(subtotal);
      root.dataset.unlocked = eligible ? "true" : "false";
      if (message) {
        if (eligible) message.textContent = "Congratulations! You've unlocked FREE DELIVERY 🎉";
        else if (itemCount > 0) message.textContent = "Add " + formatRupees(threshold - subtotal) + " more to unlock FREE DELIVERY!";
        else message.textContent = "Add items to unlock FREE STANDARD DELIVERY on orders above Rs. 3,000.";
      }
      if (bar) bar.style.width = Math.max(0, Math.min(100, (subtotal / threshold) * 100)) + "%";
    });
  };
  let timer;
  const refreshCart = () => fetch("/cart.js", { credentials: "same-origin", headers: { "Accept": "application/json" } })
    .then((response) => { if (!response.ok) throw new Error("Cart request failed"); return response.json(); })
    .then(renderProgress).catch(() => {});
  const scheduleRefresh = (delay = 650) => { window.clearTimeout(timer); timer = window.setTimeout(refreshCart, delay); };
  const isCartInteraction = (target) => {
    if (!(target instanceof Element)) return false;
    return Boolean(target.closest('form[action*="/cart"], form[action*="/cart/add"], [name="add"], [name="updates[]"], [data-quantity-input], .qty-btn, .quantity__button, [data-cart-remove]'));
  };
  document.addEventListener("change", (event) => { if (isCartInteraction(event.target)) scheduleRefresh(500); });
  document.addEventListener("input", (event) => { if (isCartInteraction(event.target)) scheduleRefresh(500); });
  document.addEventListener("submit", (event) => { if (isCartInteraction(event.target)) scheduleRefresh(850); }, true);
  document.addEventListener("click", (event) => { if (isCartInteraction(event.target)) scheduleRefresh(850); }, true);
  ["cart:updated", "cart:refresh", "cart:change", "ajaxCart:updated", "cart:build"].forEach((eventName) => document.addEventListener(eventName, () => scheduleRefresh(250)));
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", refreshCart, { once: true });
  else refreshCart();
})();